class ProductInfo extends HTMLElement {
  constructor() {
    super();
    this.priceVaries = this.dataset.priceVaries == "true";
    this.variants = JSON.parse(
      this.querySelector(`#VariantsInfo-${this.id}`).textContent
    );
    this.init();
  }

  init() {
    this.onVariantChangeSubscriber = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this)
    );
    this.initColorFamilyItems("variant-selects .color-family__item");
  }

  getVariantByIdentifier(identifier) {
    const variant = this.variants.filter(
      (entry) => entry.identifier == identifier
    );
    return variant.length === 1 ? variant[0] : null;
  }

  handleVariantChange() {
    const selectedVariant = Array.from(
      this.querySelectorAll("variant-selects .variant-option.selected")
    )
      .map((item) => item.dataset.value)
      .join("_");
    const variant = this.getVariantByIdentifier(selectedVariant);
    if (variant) {
      this.querySelectorAll(
        `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
      ).forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        if (input) {
          input.value = variant.id;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });
      if (this.priceVaries) this.renderNewProductInfo(variant.id);
    }
  }

  renderNewProductInfo(variantId) {
    if (!variantId) return;

    if (this.abortController) this.abortController.abort();
    this.abortController = new AbortController();

    fetch(`${this.dataset.url}?variant=${variantId}&section_id=product-infos`, {
      signal: this.abortController.signal,
    })
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        this.querySelector(".sh-product__pricing").innerHTML =
          html.querySelector(".sh-product__pricing").innerHTML;
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          console.log("Fetch aborted by user");
        } else {
          console.error(error);
        }
      });
  }

  initColorFamilyItems(selector) {
    if (is_touch_device()) return;

    Array.from(this.querySelectorAll(selector)).forEach((colorItem) => {
      colorItem.addEventListener(
        "mouseenter",
        this.onColorItemInteraction.bind(this)
      );
      colorItem.addEventListener(
        "mouseleave",
        this.onColorItemInteraction.bind(this)
      );
    });
  }

  onColorItemInteraction(event) {
    const colorItem = event.target;

    const titleTarget = document.getElementById(colorItem.dataset.target);
    if (titleTarget) {
      titleTarget.textContent =
        event.type == "mouseenter"
          ? colorItem.dataset.title
          : titleTarget.dataset.default;
    }

    const previewTarget = document.getElementById(colorItem.dataset.preview);
    if (previewTarget) {
      previewTarget.querySelector(".inner").innerHTML =
        event.type == "mouseenter"
          ? colorItem.querySelector("a").innerHTML
          : "";
      if (event.type === "mouseenter") {
        previewTarget.classList.remove("hidden");
      } else {
        previewTarget.classList.add("hidden");
      }
    }
  }
}
customElements.define("product-info", ProductInfo);
